import { createReducer } from '../utils';

const initialState = false;

export default createReducer(initialState, {
  REQUEST_VIEW_SEARCH: () => false,
  REQUEST_BANKRUPTCY_SEARCH: () => false,
  REQUEST_BANKRUPTCY_LOCAL_SEARCH: () => false,
  REQUEST_APPELLATE_SEARCH: () => false,
  REQUEST_CIVIL_SEARCH: () => false,
  REQUEST_CRIMINAL_SEARCH: () => false,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/immediateSearch.js